<div class="page tableSectionCommonStyle">
  <div class="tableContainer">
    <table
      mat-table
      [dataSource]="getPlayersList()"
      class="wholeTableStyle"
    >
      <ng-container matColumnDef="avatar">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell playerAvatarCell"
        >
        <div
          class="tableHeaderCellContent"
        ></div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          <div class="playerAvatarCellContentWrapper">
            <div
              class="playerAvatarCellContent"
            >
              <span
                *ngIf="getPlayerCountryCode(player)"
                class="fi fi-{{getPlayerCountryCode(player)}} flagIconStyle"
              ></span>
                <img
                  [src]="getPlayerImage(player)"
                  alt="Фото игрока"
                  width="100%"
                  height="100%"
                  class="playerAvatarStyle"
                >
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="fullName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            id="{{getHeadersIds()[0]}}"
            class="tableHeaderCellContent"
            (click)="headerCellClickHandler($event)"
          >
            <div
              class="headerName"
            >
              Фамилия Имя Отчество
            </div>
            <div class="sortIconsSection">
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[0] && dictOfOrders.ascending === Order"
              >
                expand_less
              </mat-icon>
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[0] && dictOfOrders.descending === Order"
              >
                expand_more
              </mat-icon>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          <div class="nameSurnameShell">
            <div
              id="{{getPlayerId(player)}}"
              class="nameSurnameStyle"
              (click)="playerFullNameClickHandler($event)"
            >
              {{getPlayerFullName(player)}}
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="birthYear">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            id="{{getHeadersIds()[1]}}"
            class="tableHeaderCellContent"
            (click)="headerCellClickHandler($event)"
          >
            <div
              class="headerName"
            >
              Г.р.
            </div>
            <div class="sortIconsSection">
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[1] && dictOfOrders.ascending === Order"
              >
                expand_less
              </mat-icon>
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[1] && dictOfOrders.descending === Order"
              >
                expand_more
              </mat-icon>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          {{getPlayerBirthYear(player)}}
        </td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            id="{{getHeadersIds()[2]}}"
            class="tableHeaderCellContent"
            (click)="headerCellClickHandler($event)"
          >
            <div
              class="headerName"
            >
              Зв.
            </div>
            <div class="sortIconsSection">
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[2] && dictOfOrders.ascending === Order"
              >
                expand_less
              </mat-icon>
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[2] && dictOfOrders.descending === Order"
              >
                expand_more
              </mat-icon>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          {{getPlayerTitle(player)}}
        </td>
      </ng-container>
      <ng-container matColumnDef="cityCountry">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            id="{{getHeadersIds()[3]}}"
            class="tableHeaderCellContent"
            (click)="headerCellClickHandler($event)"
          >
            <div
              class="headerName"
            >
              Страна, город
            </div>
            <div class="sortIconsSection">
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[3] && dictOfOrders.ascending === Order"
              >
                expand_less
              </mat-icon>
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[3] && dictOfOrders.descending === Order"
              >
                expand_more
              </mat-icon>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          <div class="cityCountryContent">
            <div
              class="planetGridStyle"
              *ngIf="player?.city"
            >
              <img src="/static/img/PlanetGrid.svg">
            </div>
            <div>
              {{getPlayerCountryAndCity(player)}}
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="playedDuels">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            id="{{getHeadersIds()[4]}}"
            class="tableHeaderCellContent"
            (click)="headerCellClickHandler($event)"
          >
            <div
              class="headerName"
            >
              Игр
            </div>
            <div class="sortIconsSection">
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized]="getChooseColumn() === getHeadersIds()[4] && dictOfOrders.ascending === Order"
              >
                expand_less
              </mat-icon>
              <mat-icon
                class="smallSortArrow"
                [class.arrowColorized] = "getChooseColumn() === getHeadersIds()[4] && dictOfOrders.descending === Order"
              >
                expand_more
              </mat-icon>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let player"
          class="tableRowCell"
        >
          {{getPlayedDuelsNumber(player)}}
        </td>
      </ng-container>
      <tr
        mat-header-row
        class="tableStickyHeader"
        *matHeaderRowDef="getDisplayedColumns()"
      ></tr>
      <tr
        mat-row
        class="tableRow"
        *matRowDef="let row; columns: getDisplayedColumns()"
      ></tr>
    </table>
    <div id="lookedDataInTable"></div>
  </div>
</div>
